import type { Quotation, QuotationStatus } from './types';

export const QUOTATION_STATUSES: { value: QuotationStatus; labelKey: string; color: string }[] = [
  {
    value: 'draft',
    labelKey: 'quotation.status.draft',
    color: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  },
  {
    value: 'sent',
    labelKey: 'quotation.status.sent',
    color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  },
  {
    value: 'accepted',
    labelKey: 'quotation.status.accepted',
    color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  },
  {
    value: 'rejected',
    labelKey: 'quotation.status.rejected',
    color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  },
  {
    value: 'expired',
    labelKey: 'quotation.status.expired',
    color: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300',
  },
  {
    value: 'converted',
    labelKey: 'quotation.status.converted',
    color: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
  },
];

export const MOCK_QUOTATIONS: Quotation[] = [
  {
    id: 'q-001',
    quotationNumber: 'AJ-2026-0001',
    status: 'sent',
    worksheetId: 'ws-001',
    worksheetNumber: 'ML-2026-0042',
    partnerId: 'p-001',
    partnerName: 'Kovács és Társa Kft.',
    partnerEmail: 'info@kovacskft.hu',
    partnerPhone: '+36 1 234 5678',
    createdAt: '2026-01-15T10:30:00Z',
    sentAt: '2026-01-15T11:00:00Z',
    validUntil: '2026-01-30T23:59:59Z',
    items: [
      {
        id: 'qi-001',
        productId: 'prod-006',
        description: 'Makita CB-430 szénkefe pár',
        quantity: 2,
        unit: 'db',
        unitPriceNet: 1500,
        vatRate: 27,
        totalNet: 3000,
        totalGross: 3810,
      },
      {
        id: 'qi-002',
        description: 'Munkadíj - szénkefe csere',
        quantity: 1,
        unit: 'óra',
        unitPriceNet: 8000,
        vatRate: 27,
        totalNet: 8000,
        totalGross: 10160,
      },
    ],
    subtotalNet: 11000,
    vatAmount: 2970,
    totalGross: 13970,
    notes: 'A javítás kb. 1 órát vesz igénybe. Az alkatrész készleten van.',
    createdBy: 'Szabó Béla',
  },
  {
    id: 'q-002',
    quotationNumber: 'AJ-2026-0002',
    status: 'accepted',
    worksheetId: 'ws-002',
    worksheetNumber: 'ML-2026-0038',
    partnerId: 'p-003',
    partnerName: 'Építőipari Megoldások Zrt.',
    partnerEmail: 'rendeles@epmeg.hu',
    partnerPhone: '+36 1 555 1234',
    createdAt: '2026-01-10T14:00:00Z',
    sentAt: '2026-01-10T14:30:00Z',
    validUntil: '2026-01-25T23:59:59Z',
    respondedAt: '2026-01-12T09:15:00Z',
    items: [
      {
        id: 'qi-003',
        productId: 'prod-001',
        description: 'Makita DHP481RTJ motor tekercselés',
        quantity: 1,
        unit: 'db',
        unitPriceNet: 25000,
        vatRate: 27,
        totalNet: 25000,
        totalGross: 31750,
      },
      {
        id: 'qi-004',
        description: 'Munkadíj - motor javítás',
        quantity: 3,
        unit: 'óra',
        unitPriceNet: 8000,
        vatRate: 27,
        totalNet: 24000,
        totalGross: 30480,
      },
    ],
    subtotalNet: 49000,
    vatAmount: 13230,
    totalGross: 62230,
    notes: 'Motor tekercselés garanciális munkával. Várható elkészülés: 3 munkanap.',
    internalNotes: 'VIP ügyfél - 10% kedvezmény már benne van',
    createdBy: 'Kiss Anna',
  },
  {
    id: 'q-003',
    quotationNumber: 'AJ-2026-0003',
    status: 'rejected',
    worksheetId: 'ws-003',
    worksheetNumber: 'ML-2026-0035',
    partnerId: 'p-002',
    partnerName: 'Szabó Péter',
    partnerEmail: 'szabo.peter@gmail.com',
    partnerPhone: '+36 70 987 6543',
    createdAt: '2026-01-08T09:00:00Z',
    sentAt: '2026-01-08T09:30:00Z',
    validUntil: '2026-01-23T23:59:59Z',
    respondedAt: '2026-01-09T16:00:00Z',
    items: [
      {
        id: 'qi-005',
        description: 'Hilti TE 60 ütőmű csere',
        quantity: 1,
        unit: 'db',
        unitPriceNet: 85000,
        vatRate: 27,
        totalNet: 85000,
        totalGross: 107950,
      },
      {
        id: 'qi-006',
        description: 'Munkadíj - teljes szétszerelés és összerakás',
        quantity: 4,
        unit: 'óra',
        unitPriceNet: 8000,
        vatRate: 27,
        totalNet: 32000,
        totalGross: 40640,
      },
    ],
    subtotalNet: 117000,
    vatAmount: 31590,
    totalGross: 148590,
    notes: 'Az ütőmű cseréje új alkatrésszel. A gép 3 napon belül elkészül.',
    internalNotes: 'Túl drágának találta - nem kéri a javítást',
    createdBy: 'Szabó Béla',
  },
  {
    id: 'q-004',
    quotationNumber: 'AJ-2026-0004',
    status: 'draft',
    partnerId: 'p-007',
    partnerName: 'Dunántúli Építők Kft.',
    partnerEmail: 'info@dunep.hu',
    partnerPhone: '+36 96 123 456',
    createdAt: '2026-01-18T08:00:00Z',
    validUntil: '2026-02-02T23:59:59Z',
    items: [
      {
        id: 'qi-007',
        productId: 'prod-002',
        description: 'Makita GA5050 sarokcsiszoló - új gép',
        quantity: 2,
        unit: 'db',
        unitPriceNet: 45000,
        vatRate: 27,
        totalNet: 90000,
        totalGross: 114300,
      },
      {
        id: 'qi-008',
        productId: 'prod-005',
        description: 'Bosch vágókorong 125mm (10db/csomag)',
        quantity: 5,
        unit: 'csomag',
        unitPriceNet: 2900,
        vatRate: 27,
        totalNet: 14500,
        totalGross: 18415,
      },
    ],
    subtotalNet: 104500,
    vatAmount: 28215,
    totalGross: 132715,
    notes: 'Készleten lévő termékek, azonnali kiszállítás lehetséges.',
    createdBy: 'Kiss Anna',
  },
  {
    id: 'q-005',
    quotationNumber: 'AJ-2025-0089',
    status: 'expired',
    worksheetId: 'ws-old',
    worksheetNumber: 'ML-2025-0412',
    partnerId: 'p-006',
    partnerName: 'Kiss László',
    partnerPhone: '+36 30 111 2233',
    createdAt: '2025-12-10T11:00:00Z',
    sentAt: '2025-12-10T11:30:00Z',
    validUntil: '2025-12-25T23:59:59Z',
    items: [
      {
        id: 'qi-009',
        description: 'Régi típusú kalapács javítása',
        quantity: 1,
        unit: 'db',
        unitPriceNet: 5000,
        vatRate: 27,
        totalNet: 5000,
        totalGross: 6350,
      },
    ],
    subtotalNet: 5000,
    vatAmount: 1350,
    totalGross: 6350,
    notes: 'Kisebb javítás, 1 nap alatt elkészül.',
    internalNotes: 'Ügyfél nem reagált az árajánlatra',
    createdBy: 'Szabó Béla',
  },
];
